package se.mittpass.shared.translation

enum class Language(val code: String, val displayName: String, val isRtl: Boolean = false) {
    SV("sv", "Svenska"),
    EN("en", "English"),
    AR("ar", "العربية", isRtl = true),
    DE("de", "Deutsch");

    companion object {
        fun fromCode(code: String?): Language {
            return entries.firstOrNull { it.code.lowercase() == code?.lowercase() } ?: SV
        }
    }
}
